import {
  ADD_PROJECT,
  PROJECTS,
  PROJECT,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
  ADD_PENDING_PROGRESS,
  REMOVE_PENDING_PROGRESS,
  CLEAR_ITEMS,
  SET_LOGS,
  SET_LOGS_LOADING,
} from './mutation-types';

export default {
  [ADD_PROJECT](state, payload) {
    state.items = payload;
  },
  [PROJECTS](state, payload) {
    if (state.items.length > 0) {
      let items = [...state.items];
      if (!!state.sort.filter) {
        items = items.filter((item) => item.name.indexOf(state.sort.filter) !== -1);
      }
      const itemsIds = items.map(item => item.id);
      const pendingProgressUpdate = [...state.pendingProgressUpdate];
      payload.forEach((item) => {
        if (item.isRunning && pendingProgressUpdate.indexOf(item.id) === -1) {
          pendingProgressUpdate.push(item.id);
        }
        const index = itemsIds.indexOf(item.id);
        if (index > -1) {
          items[index] = item;
        } else {
          items.push(item);
        }
      });
      state.items = items;
      state.pendingProgressUpdate = pendingProgressUpdate;
    } else {
      const pendingProgressUpdate = [];
      payload.forEach((item) => {
        if (item.isRunning) {
          pendingProgressUpdate.push(item.id);
        }
      });
      state.items = payload;
      state.pendingProgressUpdate = pendingProgressUpdate;
    }
  },
  [PROJECT](state, payload) {
    state.items = state.items.map(item => (item.id === payload.id ? Object.assign({}, item, payload) : item));
  },
  [DELETE](state, payload) {
    if (Array.isArray(payload)) {
      state.items = state.items.filter(item => payload.indexOf(item.id) === -1);
    } else {
      state.items = state.items.filter(item => item.id !== payload);
    }
  },
  [SORT](state, payload) {
    state.sort = payload;
  },
  [MORE](state, payload) {
    state.more = payload;
  },
  [LOADING](state, payload) {
    state.loading = payload;
  },
  [TOTAL](state, payload) {
    state.total = payload;
  },
  [ADD_PENDING_PROGRESS](state, payload) {
    state.pendingProgressUpdate.push(payload);
  },
  [REMOVE_PENDING_PROGRESS](state, payload) {
    state.items = payload;
    state.pendingProgressUpdate = [];
  },
  [CLEAR_ITEMS](state) {
    state.items = [];
    state.total = 0;
    state.more = true;
  },
  [SET_LOGS](state, payload) {
    state.logs = payload;
  },
  [SET_LOGS_LOADING](state, payload) {
    state.logs.loading = payload;
  },
};
